import { render, staticRenderFns } from "./InventarioArmasComponent.vue?vue&type=template&id=008820c6&scoped=true"
import script from "./InventarioArmasComponent.vue?vue&type=script&lang=js"
export * from "./InventarioArmasComponent.vue?vue&type=script&lang=js"
import style0 from "./InventarioArmasComponent.vue?vue&type=style&index=0&id=008820c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008820c6",
  null
  
)

export default component.exports